var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// project imports
import { get } from "../utils";
import { themeHelpers } from './helpers';
function parseLssProp(styles, lss, theme, rootLss) {
    var keys = Object.keys(lss);
    var length = keys.length;
    var _loop_1 = function (i) {
        var lssProp = keys[i];
        var value = lss[lssProp];
        if (value === null || value === undefined) {
            return "continue";
        }
        // If the prop is a breakpoint breakpoints
        if (typeof theme.breakpoints[lssProp] !== 'undefined') {
            styles["@media (min-width: " + theme.breakpoints[lssProp] + ")"] = parseLssProp({}, value, theme, rootLss || lss);
            return "continue";
        }
        // Pseudo Selectors and custom classes
        // is an object, let's parse it for the children
        if (typeof value === 'object') {
            styles[lssProp] = parseLssProp({}, value, theme, rootLss || lss);
            return "continue";
        }
        var helper = themeHelpers[lssProp];
        if (!helper) {
            if (lssProp === 'content') {
                styles[lssProp] = "\"" + value + "\"";
            }
            else {
                if (typeof value === 'function') {
                    value = value({ theme: theme, lss: rootLss || lss });
                }
                styles[lssProp] = value;
            }
            return "continue";
        }
        var key = undefined;
        var cssProp = lssProp;
        // helper is a string, we assume is a key on the themeLucid
        if (typeof helper === 'string') {
            key = helper;
        }
        else if (typeof helper === 'object') {
            if ('key' in helper) {
                key = helper.key;
            }
            if (typeof helper.css !== 'undefined') {
                cssProp = helper.css;
            }
        }
        if (typeof value === 'function') {
            value = value({ theme: theme, lss: rootLss || lss });
        }
        if (key !== undefined) {
            var themeValue = get(theme[key], value);
            value = themeValue || value;
        }
        if (Array.isArray(cssProp)) {
            cssProp.forEach(function (css) {
                styles[css] = value;
            });
        }
        else if (typeof value === 'object') {
            Object.assign(styles, value);
        }
        else {
            styles[cssProp] = value;
        }
    };
    for (var i = 0; i < length; i++) {
        _loop_1(i);
    }
    return styles;
}
function parseDefault(lss, props, defaults) {
    return typeof defaults === 'function'
        ? Object.assign({}, defaults(props), lss)
        : typeof defaults === 'object'
            ? Object.assign({}, defaults, lss)
            : lss;
}
export var themeLss = function (defaults) { return function (_a) {
    var theme = _a.theme, _b = _a.lss, lss = _b === void 0 ? {} : _b, props = __rest(_a, ["theme", "lss"]);
    var result = parseLssProp({}, parseDefault(lss, props, defaults), theme);
    return result;
}; };
//# sourceMappingURL=lss.js.map